import { getOriginCustomerId } from "@origin-digital/auth-utils";
import {
  fetchAccessToken,
  fetchPlatformParameters,
} from "@origin-digital/event-dispatcher";
import { CustomerType } from "@origin-digital/platform-enums";
import { getUserInfo } from "./helpers";

export type UserInfo = {
  type: "KRAKEN" | "SAP";
};

export enum Backend {
  Kraken = "KRAKEN",
  Sap = "SAP",
  Unknown = "UNKNOWN",
}

export const getSessionCustomerType = async (): Promise<Backend> => {
  const platform = await fetchPlatformParameters({});
  if (!platform) {
    return Backend.Unknown;
  }
  if (platform.customerType === CustomerType.kraken) {
    return Backend.Kraken;
  }
  if (platform.customerType === CustomerType.sap) {
    return Backend.Sap;
  }

  return Backend.Unknown;
};

export const getCustomerId = async (): Promise<string | undefined> => {
  const cachedJWT = await fetchAccessToken({});
  if (!cachedJWT) {
    return undefined;
  }
  const UID = getOriginCustomerId(cachedJWT.accessToken);

  if (!UID) {
    return undefined;
  }

  return UID;
};

export const getStoredCustomerType = async (): Promise<Backend> => {
  const user = await getUserInfo();

  if (!user) {
    return Backend.Unknown;
  }

  if (user.type === Backend.Kraken) {
    return Backend.Kraken;
  }

  if (user.type === Backend.Sap) {
    return Backend.Sap;
  }

  return Backend.Unknown;
};
